import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import styles from "./MatchingImportCancelConfirmModal.module.css";

export interface MatchingImportCancelConfirmModalProps {
  isOpen: boolean;
  onKeepImporting: () => void;
  onCancelAnyway: () => void;
}

/**
 * Confirms abandoning an in-progress matching import (Cancel import).
 * Uses a dedicated boolean `isOpen` (Pay Component / Work Patterns pattern)
 * so the design-system Modal can tear down its underlay cleanly — a shared
 * mode=null unmount was leaving click-blocking overlays on the sticky footer.
 */
export function MatchingImportCancelConfirmModal({
  isOpen,
  onKeepImporting,
  onCancelAnyway,
}: MatchingImportCancelConfirmModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onKeepImporting();
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <Heading slot="title">Cancel import?</Heading>
        </div>

        <p className={styles.message}>
          You have an import in progress. If you cancel now, your uploaded rows,
          edits, and validation progress will be lost.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onKeepImporting}>
              Keep importing
            </Button>
            <Button variant="tertiary" onPress={onCancelAnyway}>
              Cancel anyway
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
